/** @module Camunda/ProcessActiveRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/widget/CustomIconWithLabel",
	"csi/widget/MaterialIconWithLabel",
	"./main"
], function (declare, Renderer, locale, CustomIconWithLabel, MaterialIconWithLabel, Camunda) {

	return declare(Renderer, {
		/**
		 * @override
		 * Render icon and text
		 */
		toHtmlStatic: function (ctx, h, refNode, actionData) {
			const node = ctx.getNode();
			const state = node.ActivityState;
			const label = locale.capitalizeResource(state);

			switch (state) {
				case Camunda.STATE_STARTED:
					new CustomIconWithLabel({
						icon: "process",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_COMPLETED:
					new MaterialIconWithLabel({
						icon: "check_circle",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_SUSPENDED:
					new MaterialIconWithLabel({
						icon: "pause_circle",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_CANCELLED:
					new MaterialIconWithLabel({
						icon: "cancel",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_ERROR:
					new MaterialIconWithLabel({
						icon: "cancel",
						iconCss: "csi-camunda-state-error",
						label: label
					}).placeAt(refNode);
					break;
			}

			return true;
		}
	});
});